(function () {
  const root = document.querySelector("[data-jp-pdp]");
  if (!root) return;

  const variants = JSON.parse(root.getAttribute("data-variants") || "[]");
  const siddhExtra = parseInt(root.getAttribute("data-siddh") || "100", 10);
  const money = (n) =>
    "₹" +
    Number(n).toLocaleString("en-IN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

  let mediaIndex = 0;
  const slides = Array.from(root.querySelectorAll("[data-jp-slide]"));
  const mainImg = root.querySelector("[data-jp-main-img]");
  function showSlide(i) {
    if (!slides.length) return;
    mediaIndex = (i + slides.length) % slides.length;
    const src = slides[mediaIndex].getAttribute("data-src");
    const srcset = slides[mediaIndex].getAttribute("data-srcset");
    const alt = slides[mediaIndex].getAttribute("data-alt") || "";
    if (mainImg && src) {
      mainImg.style.opacity = "0.35";
      mainImg.onload = mainImg.onerror = () => {
        mainImg.style.opacity = "1";
      };
      if (srcset) {
        mainImg.srcset = srcset;
        mainImg.sizes = "(min-width: 990px) 48vw, 100vw";
      } else {
        mainImg.removeAttribute("srcset");
        mainImg.removeAttribute("sizes");
      }
      mainImg.src = src;
      mainImg.alt = alt;
      if (mainImg.complete) mainImg.style.opacity = "1";
    }
    root.querySelectorAll("[data-jp-slide]").forEach((el, idx) => {
      el.classList.toggle("is-active", idx === mediaIndex);
    });
  }
  root.querySelector("[data-jp-prev]")?.addEventListener("click", () => showSlide(mediaIndex - 1));
  root.querySelector("[data-jp-next]")?.addEventListener("click", () => showSlide(mediaIndex + 1));
  root.querySelectorAll("[data-jp-slide]").forEach((el, idx) => {
    el.addEventListener("click", () => showSlide(idx));
  });

  const optionNames = JSON.parse(root.getAttribute("data-options") || "[]");
  const selected = {};
  optionNames.forEach((name, idx) => {
    const first = root.querySelector('[data-jp-option="' + idx + '"].is-active');
    selected[name] = first ? first.getAttribute("data-value") : "";
  });

  function currentVariant() {
    return (
      variants.find((v) =>
        optionNames.every((name, i) => String(v.options[i]) === String(selected[name]))
      ) || variants[0]
    );
  }

  function updatePrice() {
    const v = currentVariant();
    if (!v) return;
    const siddhOn = root.querySelector("[data-jp-siddh]")?.checked;
    const extra = siddhOn ? siddhExtra : 0;
    const sale = (v.price + extra * 100) / 100;
    const compare = v.compare_at_price ? v.compare_at_price / 100 : 0;
    root.querySelectorAll("[data-jp-sale]").forEach((el) => {
      el.textContent = money(sale);
    });
    root.querySelectorAll("[data-jp-compare]").forEach((el) => {
      if (compare > sale) {
        el.textContent = money(compare);
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
    const offEl = root.querySelector("[data-jp-off]");
    if (offEl) {
      if (compare > sale) {
        const pct = Math.round(((compare - sale) / compare) * 100);
        const extraOff = root.getAttribute("data-extra-off") || "26";
        offEl.textContent = pct + "% + Extra " + extraOff + "% OFF";
        offEl.hidden = false;
      } else {
        offEl.hidden = true;
      }
    }
    const idInput = root.querySelector("[name='id']");
    if (idInput) idInput.value = v.id;
  }

  root.querySelectorAll("[data-jp-option]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const idx = btn.getAttribute("data-jp-option");
      const name = optionNames[idx];
      selected[name] = btn.getAttribute("data-value");
      root.querySelectorAll('[data-jp-option="' + idx + '"]').forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      updatePrice();
    });
  });

  root.querySelector("[data-jp-siddh]")?.addEventListener("change", updatePrice);

  function qtyInput() {
    return root.querySelector("[data-jp-qty]");
  }
  root.querySelectorAll("[data-jp-qty-minus]").forEach((b) =>
    b.addEventListener("click", () => {
      const q = qtyInput();
      q.value = Math.max(1, parseInt(q.value || "1", 10) - 1);
      const sticky = root.querySelector("[data-jp-qty-sticky]");
      if (sticky) sticky.value = q.value;
    })
  );
  root.querySelectorAll("[data-jp-qty-plus]").forEach((b) =>
    b.addEventListener("click", () => {
      const q = qtyInput();
      q.value = parseInt(q.value || "1", 10) + 1;
      const sticky = root.querySelector("[data-jp-qty-sticky]");
      if (sticky) sticky.value = q.value;
    })
  );

  async function addToCart(goCheckout) {
    const v = currentVariant();
    if (!v) return;
    const qty = parseInt(qtyInput()?.value || "1", 10);
    const siddhOn = root.querySelector("[data-jp-siddh]")?.checked;
    const properties = {};
    if (siddhOn) properties["Siddh / Pran Pratishtha"] = "Yes (+₹" + siddhExtra + ")";
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: v.id, quantity: qty, properties }] }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      alert(err.description || "Could not add to cart");
      return;
    }
    if (goCheckout) window.location.href = "/checkout";
    else window.location.href = "/cart";
  }

  root.querySelectorAll("[data-jp-atc]").forEach((b) =>
    b.addEventListener("click", (e) => {
      e.preventDefault();
      addToCart(false);
    })
  );
  // root.querySelectorAll("[data-jp-cod]").forEach((b) =>
  //   b.addEventListener("click", (e) => {
  //     e.preventDefault();
  //     addToCart(true);
  //   })
  // );
  root.querySelectorAll("[data-jp-cod]").forEach((b) =>
     b.addEventListener("click", (e) => {
      e.preventDefault();

      const shiprocketButton = document.querySelector(
        ".jp-cta .shiprocket-headless .sr-headless-checkout"
    );

    if (shiprocketButton) {
      shiprocketButton.click();
      return;
    }

    addToCart(true);
  })
);
  const stickyBar = root.querySelector("[data-jp-sticky]");
  const primaryCta = root.querySelector(".jp-cta");
  if (stickyBar && primaryCta) {
    const mobileQuery = window.matchMedia("(max-width: 989px)");
    let primaryPassed = false;
    const updateSticky = () => {
      const shouldShow = mobileQuery.matches || primaryPassed;
      stickyBar.classList.toggle("is-visible", shouldShow);
      stickyBar.setAttribute("aria-hidden", shouldShow ? "false" : "true");
    };

    if ("IntersectionObserver" in window) {
      const stickyObserver = new IntersectionObserver(([entry]) => {
        primaryPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        updateSticky();
      });
      stickyObserver.observe(primaryCta);
    } else {
      let stickyFrame;
      const requestStickyUpdate = () => {
        if (stickyFrame) return;
        stickyFrame = window.requestAnimationFrame(() => {
          stickyFrame = null;
          primaryPassed = primaryCta.getBoundingClientRect().bottom < 0;
          updateSticky();
        });
      };
      window.addEventListener("scroll", requestStickyUpdate, { passive: true });
    }
    mobileQuery.addEventListener?.("change", updateSticky);
    updateSticky();
  }

  root.querySelector("[data-jp-pin-check]")?.addEventListener("click", () => {
    const input = root.querySelector("[data-jp-pin]");
    const out = root.querySelector("[data-jp-pin-result]");
    const pin = (input?.value || "").trim();
    if (!/^\d{6}$/.test(pin)) {
      out.textContent = "Enter a valid 6-digit pincode";
      out.className = "jp-pin-result is-bad";
      return;
    }
    const d = new Date();
    d.setDate(d.getDate() + 5);
    const d2 = new Date();
    d2.setDate(d2.getDate() + 8);
    const fmt = (x) =>
      x.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
    out.textContent = "Estimated delivery " + fmt(d) + " – " + fmt(d2);
    out.className = "jp-pin-result is-ok";
  });

  root.querySelectorAll("[data-jp-copy]").forEach((btn) => {
    btn.addEventListener("click", async () => {
      const code = btn.getAttribute("data-jp-copy");
      try {
        await navigator.clipboard.writeText(code);
        const prev = btn.textContent;
        btn.textContent = "Copied";
        setTimeout(() => (btn.textContent = prev), 1200);
      } catch (e) {}
    });
  });

  (function rotatingSoldCount() {
    const soldEl = root.querySelector("[data-jp-sold]");
    if (!soldEl) return;

    const baseCount = parseInt(soldEl.getAttribute("data-base-sold") || "0", 10);
    if (!baseCount) return;

    const productId = root.getAttribute("data-product-id") || window.location.pathname;
    const storageKey = "divine-shiva:sold-week:" + productId;
    const minDelay = 4 * 60 * 1000;
    const maxDelay = 5 * 60 * 1000;
    const nextDelay = () => Math.floor(minDelay + Math.random() * (maxDelay - minDelay));
    const format = (value) => Number(value).toLocaleString("en-IN");
    let state = { count: baseCount, nextUpdate: Date.now() + nextDelay() };

    try {
      const saved = JSON.parse(window.localStorage.getItem(storageKey) || "null");
      if (saved && Number.isFinite(saved.count) && Number.isFinite(saved.nextUpdate)) {
        state = saved;
        if (state.count < baseCount) state.count = baseCount;
      }
    } catch (error) {}

    function save() {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(state));
      } catch (error) {}
    }

    function render() {
      soldEl.textContent = format(state.count) + " units sold last week";
    }

    function refresh() {
      const now = Date.now();
      if (now >= state.nextUpdate) {
        state.count += 1;
        state.nextUpdate = now + nextDelay();
        save();
      }
      render();
    }

    let soldTimer;
    function scheduleRefresh() {
      window.clearTimeout(soldTimer);
      if (document.hidden) return;
      const wait = Math.max(1000, Math.min(state.nextUpdate - Date.now(), 60000));
      soldTimer = window.setTimeout(() => {
        refresh();
        scheduleRefresh();
      }, wait);
    }

    refresh();
    save();
    scheduleRefresh();
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) refresh();
      scheduleRefresh();
    });
  })();

  updatePrice();

  (function offerTimer() {
    const el = root.querySelector("[data-jp-timer-text]");
    if (!el) return;
    function pad(n) {
      return String(n).padStart(2, "0");
    }
    function tick() {
      const now = new Date();
      const end = new Date(now);
      end.setHours(24, 0, 0, 0);
      let ms = end - now;
      if (ms < 0) ms = 0;
      const h = Math.floor(ms / 3600000);
      const m = Math.floor((ms % 3600000) / 60000);
      const s = Math.floor((ms % 60000) / 1000);
      el.textContent = pad(h) + " hr : " + pad(m) + " min : " + pad(s) + " sec";
    }
    let timer;
    function startTimer() {
      window.clearInterval(timer);
      if (document.hidden) return;
      tick();
      timer = window.setInterval(tick, 1000);
    }
    startTimer();
    document.addEventListener("visibilitychange", startTimer);
  })();
})();
